import React from "react";
import { NavLink } from "react-router-dom";
import { navList } from "./nav";

const NavbarMobile = ({ show, handleShow }) => {
  return (
    <>
      <nav
        className={`fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform bg-neutral-3 w-80 dark:bg-gray-800 flex flex-col justify-start items-center lg:hidden drop-shadow-2xl border-r-2 border-black/20 rounded-e-xl
        ${show ? "" : "-translate-x-full"}`}
      >
        <button
          type="button"
          aria-label="Close menu"
          className="text-blue-6 cursor-pointer transition-all duration-200 justify-end flex w-full"
          onClick={() => handleShow(false)}
        >
          <span className="material-icons" aria-hidden="true">close</span>
        </button>

        <NavLink
          className="flex items-center w-full mb-4"
          to="/"
          aria-label="Clear Choice Cleaning Services home"
        >
          <img
            src="/assets/images/logo/logo_new.webp"
            alt="Clear Choice Cleaning Services"
            width="280"
            height="86"
            className="w-[280px]"
          />
        </NavLink>

        <div className="flex flex-col w-full gap-5 items-start">
          {navList.map((nav, index) => (
            <NavLink
              key={index}
              to={nav.url}
              className={({ isActive }) =>
                "cursor-pointer text-md py-1 px-2 rounded-md" +
                (isActive
                  ? " bg-blue-6/90 text-white "
                  : " text-blue-6 hover:text-blue-8")
              }
              onClick={() => handleShow(false)}
            >
              {nav.name}
            </NavLink>
          ))}
          <NavLink
            to="/quote"
            className={({ isActive }) =>
              "cursor-pointer text-md text-white linear-stroke drop-shadow bg-blue-7 py-3 px-4 transition-all " +
              (isActive
                ? " text-yellow-200"
                : " hover:text-yellow-200 hover:bg-blue-6")
            }
            onClick={() => handleShow(false)}
          >
            Get a Free Quote
          </NavLink>
        </div>
      </nav>
      <div
        className={`w-screen h-screen bg-black/30 absolute top-0 left-0 z-0 ${
          show ? "flex" : "hidden"
        }`}
        onClick={() => handleShow(false)}
      ></div>
    </>
  );
};

export default NavbarMobile;
